import React, { useCallback } from 'react';
import { useRouteError, Link } from "react-router-dom";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './ErrorPage.css';

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <div className="error-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col lg={6} className="text-center">
            <div className="error-content">
              <div className="error-icon">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <h1 className="error-title">Oops! Something went wrong</h1>
              <p className="error-message">
                We're sorry, but an unexpected error has occurred. 
                Don't worry, our team has been notified.
              </p>
              {error && (
                <div className="error-details">
                  <code>{error.statusText || error.message}</code>
                </div>
              )}
              <div className="error-actions">
                <Link to="/" className="btn btn-primary btn-lg me-3">
                  <FontAwesomeIcon icon={faHome} className="me-2" />
                  Go Home
                </Link>
                <Button 
                  variant="outline-secondary" 
                  size="lg"
                  onClick={handleReload}
                >
                  Try Again
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}